import Swiper from 'swiper/dist/js/swiper'



const lightboxWrapper = document.querySelectorAll(".team-wrapper");

lightboxWrapper.forEach((item, index) => {
  item.setAttribute('id', `team${index}`)
  createLightbox(item.getAttribute('id'))
});
function createLightbox (id) {
  const lightboxImages = document.querySelectorAll('#'+id+' [lightbox-toggle]');

  if (lightboxImages.length > 0) {

    let swiper;
    window.globals = {};
    const body = document.getElementsByTagName("body")[0];
    const initLightbox = lightboxImages.length > 0;
    const destroySwiper = (swiper, timeout) => {
      setTimeout(() => {
        if(typeof swiper !== 'undefined' && typeof swiper.destroy === 'function') {
          swiper.destroy();
        }
      }, timeout);
    };

    const createLightboxSkeleton = () => {
      // Create skeleton for lightbox
      const lightbox = document.createElement("div");
      const lightboxContainer = document.createElement("div");
      const lightboxClose = document.createElement("div");
      const lightboxClosebig = document.createElement("div");
      const swiperContainer = document.createElement("div");
      const swiperWrapper = document.createElement("div");
      const swiperBtnNext = document.createElement("div");
      const swiperBtnPrev = document.createElement("div");
      const swiperPagination = document.createElement("div");

      // Add classes
      lightbox.classList.add("c-lightbox", 'team-carrousel-wrapper', id);
      lightboxContainer.classList.add("c-lightbox__container", "team-carrousel", "large", "p5", "pb10")
      lightboxClose.classList.add("c-lightbox__close");
      lightboxClosebig.classList.add("c-lightbox__close", "bigclose");
      lightboxClose.setAttribute("tabindex", "0");
      lightboxClose.innerHTML = "X";
      swiperContainer.classList.add("swiper-container");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperBtnNext.classList.add("swiper-button-next");
      swiperBtnPrev.classList.add("swiper-button-prev");
      swiperPagination.classList.add("swiper-pagination");

      // Append created divs
      lightboxContainer.appendChild(lightboxClose);
      lightboxContainer.appendChild(lightboxClosebig);
      swiperContainer.appendChild(swiperWrapper);
      swiperContainer.appendChild(swiperBtnNext);
      swiperContainer.appendChild(swiperBtnPrev);
      swiperContainer.appendChild(swiperPagination);
      lightboxContainer.appendChild(swiperContainer);
      lightbox.appendChild(lightboxContainer);
      body.appendChild(lightbox);

      // Set variables to reference the lightbox
      globals.lightboxRef = document.querySelector('.c-lightbox.'+id+'');
      globals.swiperWrapperRef = globals.lightboxRef.querySelector(
        ".swiper-wrapper"
      );
    };

    if (initLightbox) {
      createLightboxSkeleton();

      // The rest of the code will go here
      lightboxImages.forEach(function (el, index) {
        // Add click function to lightbox images
        el.addEventListener("click", imageClick, false);

        function imageClick() {
          // Clear swiper before trying to add to it
          globals.swiperWrapperRef.innerHTML = "";

          // Loop through images with lightbox data attr
          // Create html for lightbox carousel
          lightboxImages.forEach(function (img) {
            // Create clone of current image in loop
            const image = img.cloneNode(true);
            // Create divs
            const slide = document.createElement("div");
            const imageContainer = document.createElement("div");
            // Add classes
            slide.classList.add("swiper-slide");
            imageContainer.classList.add("c-lightbox__image", "slide-member-item");
            // Append images to the slides, then slides to swiper wrapper
            imageContainer.appendChild(image);
            slide.appendChild(imageContainer);
            globals.swiperWrapperRef.appendChild(slide);
          });

          // Init Swiper
          swiper = new Swiper(".c-lightbox .swiper-container", {
            initialSlide: index,
            loop: false,
            slidesPerView: 1,
            speed: 750,
            spaceBetween: 0,
            effect: "fade",
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            pagination: {
              el: ".swiper-pagination"
            },
            keyboard: {
              enabled: true,
              onlyInViewport: true
            },
          });

          // Add the class to open the lightbox
          // Add overflow hidden to the body to prevent scrolling
          globals.lightboxRef.classList.add("open");
          body.classList.add("overflowHidden");
        }
      });

      // Close lightbox on click
      document.addEventListener(
        "click",
        ({ target }) => {
          if (target.matches(".c-lightbox__close")) {
            destroySwiper(swiper, 250);
            globals.lightboxRef.classList.remove("open");
            body.classList.remove("overflowHidden");
          }
        },
        false
      );

      // Close lightbox on escape key press
      document.addEventListener("keydown", ({ key }) => {
        if (key === "Escape") {
          destroySwiper(swiper, 250);
          globals.lightboxRef.classList.remove("open");
          body.classList.remove("overflowHidden");
        }
      })
    }
  }

}
